import { render, staticRenderFns } from "./TimeSetup.vue?vue&type=template&id=12999fba&scoped=true"
import script from "./TimeSetup.vue?vue&type=script&lang=js"
export * from "./TimeSetup.vue?vue&type=script&lang=js"
import style0 from "./TimeSetup.vue?vue&type=style&index=0&id=12999fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12999fba",
  null
  
)

export default component.exports